import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { PageNotFound } from '../../youwell-common/components';
import urls from '../../app/urls';

import ProgramError from './components/ProgramError';
import TaskGroup from './TaskGroup';
import TaskPage, { TaskPageRedirect } from './TaskPage';

class Index extends React.Component {
    render() {
        const {
            currentProgram,
        } = this.props;

        if (!currentProgram) {
            return <ProgramError />;
        }

        return (
            <Switch>
                <Route exact path={`${urls.inside.program}/:elementGroup`} component={TaskGroup} />
                <Route exact path={`${urls.inside.program}/:elementGroup/:elementIndex/${urls.inside.parts.resumeLatest}`} component={TaskPageRedirect} />
                <Route exact path={`${urls.inside.program}/:elementGroup/:elementIndex/:subIndex?`} component={TaskPage} />
                <Route component={PageNotFound} />
            </Switch>
        );
    }
}

Index.propTypes = {
    currentProgram: PropTypes.object,
};

Index.defaultProps = {
    currentProgram: null,
};

const mapStateToProps = state => ({
    currentProgram: state.programStore.currentProgram,
});

export default connect(mapStateToProps)(Index);
